<!-- MODAL Agregar documento recibido manualmente -->
<div mdbModal #agregarDoc="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Agregar documento
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseDocRecManualmente()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="filtros-body">
          <form autocomplete="off" [formGroup]="formHeader">
            <div class="row">

              <div class="col" style="max-width: 100px">
                <div class="md-form mb-0">
                  <mdb-select label="Mes/Periodo" [options]="optionsMonth" placeholder="Mes/Periodo"
                    [filterEnabled]="true" formControlName="mesPeriodo">
                  </mdb-select>
                  <div *ngIf="
              formHeader.get('mesPeriodo').invalid &&
              (formHeader.get('mesPeriodo').dirty ||
              formHeader.get('mesPeriodo').touched)
            ">
                    <mdb-error *ngIf="formHeader.get('mesPeriodo').hasError('required')">Ingrese periodo
                    </mdb-error>
                  </div>
                </div>
              </div>


              <div class="col" style="max-width: 100px">
                <div class="md-form mb-0">
                  <mdb-select label="Gestión" [options]="optionsYear" placeholder="Gestión" [filterEnabled]="true"
                    formControlName="gestion">
                  </mdb-select>
                  <div *ngIf="
              formHeader.get('gestion').invalid &&
              (formHeader.get('gestion').dirty ||
              formHeader.get('gestion').touched)
            ">
                    <mdb-error *ngIf="formHeader.get('gestion').hasError('required')">Ingrese gestión
                    </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col" style="max-width: 150px;">
                <div class="md-form">
                  <input (input)="changeProveedorRut($event.target.value)" value="" type="text" class="form-control"
                    placeholder="" required formControlName="rutProveedor" formatRut />
                  <label for="rutproveedor">RUT Proveedor</label>
                  <div *ngIf="
                formHeader.get('rutProveedor').invalid &&
                (formHeader.get('rutProveedor').dirty ||
                formHeader.get('rutProveedor').touched)
              ">
                    <mdb-error *ngIf="formHeader.get('rutProveedor').hasError('required')">Ingrese Proveedor
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div>
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                      (click)="openModalSeleccionarProveedor()">
                      <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                  </div>
                  <div style="align-self: center;">
                    <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents;">
                      {{ proveedorSeleccionado.nombre }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <mdb-select label="Docto. Ref." [options]="optionsDoctoReferencia" [disabled]="true"
                    placeholder="Seleccionar Docto. Ref." [filterEnabled]="true" formControlName="doctoReferencia">
                  </mdb-select>
                  <span *ngIf="
                    formHeader.get('doctoReferencia').invalid &&
                    (formHeader.get('doctoReferencia').dirty ||
                    formHeader.get('doctoReferencia').touched)
                  ">
                    <mdb-error
                      *ngIf="formHeader.get('doctoReferencia').hasError('required') || formHeader.get('doctoReferencia').hasError('min')">
                      Ingrese docto. ref.
                    </mdb-error>
                  </span>
                </div>
              </div>
              <div class="col " style="max-width: 120px;">
                <div class="md-form">
                  <input value="" type="text" id="nroDoc" class="form-control" placeholder="000" #nroDoc
                    formControlName="nroDoc" [readonly]="proveedorSeleccionado === null" onlyNumbers
                    (keyup)="recibirDatosdelnroDoc($event.target.value)" />
                  <label for="nroDoc">Nro. Doc.</label>
                </div>
              </div>
              <div class="col" style="max-width: 60px;">
                <button mdbBtn [disabled]="EnableDoc === false" type="button" class="btn-cuadrado" color="secondary"
                  mdbWavesEffect (click)="abrirModalSeleccionDocumento()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
              </div>
              <div class="col hidden" style="max-width: 200px; visibility: hidden;">
                <div class="md-form">
                  <mdb-select [disabled]="true" label="Tipo de factura" formControlName="tipoFact"
                    [options]="optionsTipoFact" placeholder="Seleccionar" [filterEnabled]="true"></mdb-select>
                </div>
              </div>
              <div class="col" style="max-width: 100px;">
                <div class="md-form">
                  <input value="" (input)="OnChangeFolio($event.target.value)" type="number" class="form-control"
                    placeholder="" required formControlName="nFolio" #Folio />
                  <label for="Folio">Folio</label>
                  <div *ngIf="
                    formHeader.get('nFolio').invalid &&
                    (formHeader.get('nFolio').dirty ||
                    formHeader.get('nFolio').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('nFolio').hasError('required')">Ingrese Folio
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col" style="max-width: 150px;">
                  <div class="md-form">
                    <mdb-date-picker [inline]="true" name="fechaInicio" formControlName="FechaDoc"
                      [placeholder]="'Fecha Doc.'" required>
                    </mdb-date-picker>
                    <label for="FechaDoc">Fecha de Emision</label>
                    <div *ngIf="
                  formHeader.get('FechaDoc').invalid &&
                  (formHeader.get('FechaDoc').dirty ||
                  formHeader.get('FechaDoc').touched)
                ">
                      <mdb-error *ngIf="formHeader.get('FechaDoc').hasError('required')">Ingrese fecha de Doc.
                      </mdb-error>
                    </div>
                  </div>
                </div>

                <div class="col" style="max-width: 150px;">
                  <div class="md-form">
                    <mdb-date-picker [inline]="true" name="fechaFinal" formControlName="FechaVenc"
                      [placeholder]="'Fecha de Vencimiento'" required>
                    </mdb-date-picker>
                    <label for="FechaVenc">Fecha de vencimiento</label>
                    <div *ngIf="
                  formHeader.get('FechaVenc').invalid &&
                  (formHeader.get('FechaVenc').dirty ||
                  formHeader.get('FechaVenc').touched)
                ">
                      <mdb-error *ngIf="formHeader.get('FechaVenc').hasError('required')">Ingrese fecha de Vencimiento
                      </mdb-error>
                    </div>
                  </div>
                </div>


              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 400px">
                <!-- <div class="col">
                  <div class="md-form">
                    <mdb-select label="Condición de pago" formControlName="CondPago" [options]="optionsCondPago" placeholder="Seleccionar condición de pago"
                      [filterEnabled]="true"></mdb-select>
                  </div>
                </div> -->
                <br>
                <div class="col" style="max-width: 400px">
                  <div class="md-form">
                    <input value="" type="text" id="glosaNominal" class="form-control" formControlName="GlosaN"
                      placeholder="" #direccion />
                    <label for="glosaNominal">Glosa General</label>
                  </div>
                </div>

              </div>
              <div class="col " style="max-width: 400px">
                <div class="row">
                  <div class="col">
                    <mdb-checkbox formControlName="EntregaGratuita">Entrega gratuita </mdb-checkbox>
                    <mdb-checkbox formControlName="MontoBrutoDetalle">Montos detalle en Bruto </mdb-checkbox>
                    <mdb-checkbox formControlName="MueveInventario" (change)="changeShowInventario()">Mueve Inventario</mdb-checkbox>
                  </div>
                  <!-- <div class="col" style="max-width: 400px">
                    <mdb-checkbox formControlName="MueveInventario" (change)="changeShowInventario()">Mueve Inventario</mdb-checkbox>
                  </div> -->
                  <div class="col" style="max-width: 200px">
                    <div class="md-form" *ngIf="showBodega">
                      <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true"
                        [highlightFirst]="false" placeholder="Seleccionar Bodega" formControlName="bodega"></mdb-select>
                      <label>Bodega</label>
                    </div>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col" style="max-width: 400px" *ngIf="HiddeIvaUseComun">
                    <mdb-checkbox formControlName="IvaUsoComun" (change)="changeShowFactor()">IVA de uso
                      comun</mdb-checkbox>
                  </div>
                  <div class="col" style="max-width: 200px">
                    <div class="md-form" *ngIf="showFactor">
                      <input value="" formControlName="FactorIva" type="number" id="factor" class="form-control"
                        placeholder="Factor" required #factor />
                      <label for="factor">Factor</label>
                    </div>
                  </div>
                </div>



              </div>
            </div>

            <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
              <h4>Totales cabecera</h4>
            </div>
          </form>
          <div class="row">
            <!-- Totales -->
            <div class="col">

              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <tbody class="blue lighten-5">
                    <tr>
                      <!-- <td><strong>SubTotal</strong></td>
                        <td><strong>Desc. Gbl</strong></td>
                        <td><strong>Recargo Gbl</strong></td> -->
                      <td>
                        <div style="display: flex;">
                          <strong>Monto Neto</strong>
                        </div>
                      </td>
                      <td>
                        <div style="display: flex;">
                          <strong>Monto Exento</strong>
                        </div>
                      </td>
                      <td><strong>Desc. Global</strong></td>
                      <td><strong>Recar. Global</strong></td>
                    </tr>
                  </tbody>
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right">
                        <input value="" (input)="OnChangeTotalxAfecto($event.target.value)" [(ngModel)]="MontoAf"
                          type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" (input)="OnChangeTotalxExento($event.target.value)" [(ngModel)]="MontoEx"
                          type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="DescGbl" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="RecargoGbl" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right">
                        <div style="display: flex;">
                          <strong> Monto IVA</strong>
                        </div>
                      </td>
                      <td><strong>IVA Recuperable</strong></td>
                      <td><strong>IVA No-Recuperable</strong></td>
                      <td><strong>IVA Activo Fijo</strong></td>
                      <td><strong>IVA Retenido</strong></td>
                      <td><strong>IVA en Comun</strong></td>
                    </tr>
                  </tbody>
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right">
                        <input value="" (input)="OnChangeTotalxIva($event.target.value)" [(ngModel)]="MontoIva"
                          type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaRec" type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaNoRec" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaActF" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaRet" type="text" class="form-control" placeholder="..." monto />
                      </td>
                      <td align="right">
                        <input value="" [(ngModel)]="IvaComn" type="text" class="form-control" placeholder="..."
                          monto />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right"><strong>Total Bruto</strong></td>
                    </tr>
                  </tbody>
                  <tbody class="blue lighten-5">
                    <tr>
                      <td align="right">
                        <strong>{{ TotalBruto | numerico }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>


            </div>

            <div class="col grey lighten-5">
              <!-- Impuestos adicionales -->
              <div class="row">
                <div class="col">
                  <div style="display: flex;">
                    <h5> Impuestos Adicionales</h5>
                  </div>

                </div>
              </div>
              <form autocomplete="off" [formGroup]="formImpuestos">
                <div class="row">

                  <div class="col">
                    <div class="md-form">
                      <mdb-select label="Seleccionar" [options]="optionsSelect" placeholder="Seleccionar"
                        [filterEnabled]="true" formControlName="impAdic"></mdb-select>
                    </div>
                  </div>

                  <div class="col" style="max-width: 200px">
                    <div class="md-form">
                      <input value="{{impuesto}}" type="text" id="campo1" class="form-control" placeholder="..."
                        disabled required #campo1 />
                      <label for="campo1"></label>
                    </div>
                  </div>

                  <div class="col align-items-center">
                    <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect (click)="OnAddImpuestoAd()">
                      Agregar
                    </button>
                  </div>
                </div>
              </form>

              <div class="row">
                <div class="col">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                      <tbody class="grey lighten-5">
                        <tr>
                          <td align="center">
                            <mdb-checkbox (change)="checkAllChange($event)" [(ngModel)]="checkAll"></mdb-checkbox>
                          </td>
                          <td><strong>Código</strong></td>
                          <td><strong>Detalle</strong></td>
                          <td align="right"><strong>%</strong></td>
                        </tr>
                      </tbody>
                      <tbody *ngFor="let dynamic of dynamicArray; let i = index;" class="grey lighten-5">
                        <tr>
                          <td align="center">
                            <mdb-checkbox [checked]="dynamic.checked"
                              (change)='checkDetalle(dynamic, $event)'></mdb-checkbox>
                          </td>
                          <td>{{dynamic.codigo}}</td>
                          <td>{{dynamic.detalle}}</td>
                          <td align="right">{{dynamic.valor}}</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row justify-content-between">
                <div class="col align-items-center">
                  <button type="button" mdbBtn color="warning" size="sm" mdbWavesEffect (click)="OnDeleteDetail()">
                    <span *ngIf="countSelectImp === 0">Eliminar</span>
                    <span *ngIf="countSelectImp > 0"> Eliminar {{countSelectImp}} seleccionados</span>

                  </button>
                </div>

                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="{{montoTotal}}" type="text" id="campo1" class="form-control" placeholder="0" #campo1
                      disabled />
                    <label for="campo1">Total Impuestos adicionales</label>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <form autocomplete="off" [formGroup]="formItems">
            <div class="row filtros-header"
              style="border-bottom: 1px solid #dee2e6; justify-content: space-between; align-items: center">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <h4 class="mb-0">Ingreso de Item</h4>
                  </div>
                </div>
              </div>

            </div>


            <div formGroupName="productoExistente">
              <div class="row">
                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <mdb-select ngDefaultControl label="Tipo de Item" id="filtroItems" #Itemsfiltro
                      [options]="optionsTipoItem" placeholder="Seleccionar" [filterEnabled]="true"
                      formControlName="tipoItems" (selected)="onchangeItem($event)"></mdb-select>
                  </div>
                </div>
                <div class="col mt-3" style="display: none;">
                  <mdb-checkbox formControlName="ActivoFijo">Item es Activo Fijo</mdb-checkbox>
                </div>
              </div>
            </div>

            <!-- INGRESO DATOS CORECCION DE MONTO -->
            <ng-container *ngIf="formItems.get('esProductoLibre').value" formGroupName="productoLibre">
              <div class="row">
                <div class="col" style="max-width: 200px"
                  [ngStyle]="{'display': formItems.get('productoExistente.tipoItems').value === 4 ? 'none' : 'block'}">
                  <div class="md-form">
                    <input value="" type="text" id="codProductLibre" class="form-control" placeholder="000" required
                      #codProductLibre formControlName="codigo" monto />
                    <label for="codProductLibre">Código de producto</label>
                    <div
                      *ngIf="formItems.get('productoLibre.codigo').invalid && (formItems.get('productoLibre.codigo').dirty || formItems.get('productoLibre.codigo').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.codigo').hasError('required')">Ingrese código de
                        producto </mdb-error>
                      <mdb-error *ngIf="formItems.get('productoLibre.codigo').hasError('min')">Código de producto debe
                        ser mayor a 0 </mdb-error>
                    </div>
                  </div>
                </div>

                <div class="col" style="max-width: 530px">
                  <div class="md-form">
                    <input value="" type="text" id="descripcionProductoLibre" class="form-control" placeholder=""
                      required #descripcionProductoLibre formControlName="descripcion" />
                    <label for="descripcionProductoLibre">Descripción</label>
                    <div
                      *ngIf="formItems.get('productoLibre.descripcion').invalid && (formItems.get('productoLibre.descripcion').dirty || formItems.get('productoLibre.descripcion').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.descripcion').hasError('required')"> Ingrese
                        descripción de producto </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 150px">
                  <div class="md-form">
                    <mdb-select [options]="optionsFormatoProductoLibre" [multiple]="false" [filterEnabled]="false"
                      [highlightFirst]="false" placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
                    <label>Formato</label>
                    <div
                      *ngIf="formItems.get('productoLibre.formato').invalid && (formItems.get('productoLibre.formato').dirty || formItems.get('productoLibre.formato').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.formato').hasError('required')">Ingrese formato
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required
                      #cant formControlName="cantidad" monto />
                    <label for="cant">Cantidad</label>
                    <div
                      *ngIf="formItems.get('productoLibre.cantidad').invalid && (formItems.get('productoLibre.cantidad').dirty || formItems.get('productoLibre.cantidad').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.cantidad').hasError('required')">Ingrese cantidad
                      </mdb-error>
                      <mdb-error *ngIf="formItems.get('productoLibre.cantidad').hasError('min')">Cantidad debe ser mayor
                        a 0 </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 150px">
                  <div class="">
                    <input value="" type="text" id="precioUnitario" class="form-control" placeholder="0" required
                      #precioUnitario formControlName="precioUnitario" monto />
                    <label for="precioUnitario">Precio unitario</label>
                    <div
                      *ngIf="formItems.get('productoLibre.precioUnitario').invalid && (formItems.get('productoLibre.precioUnitario').dirty || formItems.get('productoLibre.precioUnitario').touched)">
                      <mdb-error *ngIf="formItems.get('productoLibre.precioUnitario').hasError('required')"> Ingrese
                        precio unitario </mdb-error>
                      <mdb-error *ngIf="formItems.get('productoLibre.precioUnitario').hasError('min')"> Precio unitario
                        debe ser mayor a 0 </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2 d-flex align-items-center">
                  <!-- Material inline 1 -->
                  <div class="form-check form-check-inline" style="margin-right: 20px">
                    <input type="radio" class="form-check-input" mdbInput id="producto_libre_afecto"
                      [value]="PRODUCTO_LIBRE_AFECTO" formControlName="es_exento" />
                    <label class="form-check-label" for="producto_libre_afecto">Afecto</label>
                  </div>

                  <!-- Material inline 2 -->
                  <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" mdbInput id="producto_libre_exento"
                      [value]="PRODUCTO_LIBRE_EXCENTO" formControlName="es_exento" />
                    <label class="form-check-label" for="producto_libre_exento">Exento</label>
                  </div>
                </div>

                <div class="col-sm-2">
                  <div></div>

                  <button type="button" mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="AddDetalleSinSKU()"
                    *ngIf="formItems.get('productoExistente.tipoItems').value === 4">
                    Agregar producto
                  </button>
                </div>
              </div>
            </ng-container>


          </form>

          <!--TABLA CORRECCION DE MONTO-->
          <ng-container
            *ngIf="this.formItems.get('productoExistente.tipoItems').value === 4 && this.formHeader.get('rutProveedor').value">
            <div class="p-3">
              <!-- TABLA -->
              <div class="row">
                <div class="col">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                      <tbody class="grey lighten-5">
                        <tr>
                          <td align="center">
                            <mdb-checkbox (change)="checkAllChangeDetalle($event)" [(ngModel)]="checkAllDetalle">
                            </mdb-checkbox>
                          </td>
                          <td><strong>Cod. Prod.</strong></td>
                          <td><strong>Descripción</strong></td>
                          <!-- <td><strong>Activo fijo</strong></td> -->
                          <td><strong>Cant.</strong></td>
                          <td><strong>UniMed</strong></td>
                          <td><strong>Precio-U</strong></td>
                          <td><strong>Desc.</strong></td>
                          <td><strong>Rec.</strong></td>
                          <td><strong>CodERP</strong></td>
                          <td><strong>Detalle</strong></td>
                          <td><strong>Tipo</strong></td>
                          <td><strong>Total</strong></td>
                        </tr>
                      </tbody>
                      <tbody class="grey lighten-5">
                        <tr *ngIf="AddlistaDetalleDocRec?.length === 0">
                          <td colspan="100%" style="text-align: center">No se encontró información</td>
                        </tr>
                        <tr *ngFor="let doc of AddlistaDetalleDocRec; let i = index">
                          <td align="center">
                            <mdb-checkbox [checked]="doc.additionalInfo.checked"
                              (change)="checkDetalleList(doc.additionalInfo, $event)"></mdb-checkbox>
                          </td>
                          <td>{{i+1}}</td>
                          <td>
                            <span *ngIf="doc.producto_proveedor_descripcion === null"></span>
                            <span *ngIf="doc.producto_proveedor_descripcion != null">{{
                              doc.producto_proveedor_descripcion.trim() }}</span>
                          </td>
                          <!-- <td>
                            <mdb-checkbox [checked]="doc.es_activo_fijo" onclick="return false"></mdb-checkbox>
                          </td> -->
                          <td>{{ doc.cantidad_recibida }}</td>
                          <td>{{ doc.formato_codigo }}</td>
                          <td>$ {{ doc.precio_unitario | numerico }}</td>
                          <td>
                            <span *ngIf="doc.desc_es_porcentaje === true">{{ doc.descuento }} %</span>
                            <span *ngIf="doc.desc_es_porcentaje === false">$ {{ doc.descuento | numerico }}</span>
                          </td>
                          <td>
                            <span *ngIf="doc.rec_es_porcentaje === true">{{ doc.recargo }} %</span>
                            <span *ngIf="doc.rec_es_porcentaje === false">$ {{ doc.recargo | numerico }}</span>
                          </td>
                          <td>{{ doc.sku }}</td>
                          <td>{{ doc.producto_descripcion.trim() }}</td>
                          <td>{{ doc.tipo_item_nombre }}</td>
                          <td>{{ doc.total_linea | numerico }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col align-items-center">
                  <button (click)="DeleteDetalle()" type="button" mdbBtn color="warning" size="sm" mdbWavesEffect>
                    <span *ngIf="countSelectDetalle === 0">Eliminar</span>
                    <span *ngIf="countSelectDetalle > 0"> Eliminar {{ countSelectDetalle }} seleccionados</span>
                  </button>
                </div>
                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <input value="{{ totalMontosinSKU | numerico }}" type="text" id="campo1" class="form-control"
                      placeholder="0" required #campo1 />
                    <label for="campo1">Total Detalle</label>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- PARCIAL -->
          <ng-container
            *ngIf="this.formItems.get('productoExistente.tipoItems').value != 4 && this.formHeader.get('nroDoc').value && this.formHeader.get('rutProveedor').value">
            <div class="row" *ngIf="disabledTotales === true">
              <div class="col">
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm align-middle">
                    <thead class="grey lighten-2">
                      <tr>
                        <!-- <th scope="col">
                          <mdb-checkbox></mdb-checkbox>
                        </th> -->
                        <!-- <th></th> -->
                        <th scope="col"></th>
                        <th scope="col">Código</th>
                        <th scope="col">Descripción</th>
                        <th scope="col">Cantidad</th>
                        <th scope="col">Devolver</th>
                        <th scope="col">Formato</th>
                        <th scope="col" class="text-right">Precio $</th>
                        <th scope="col" class="text-right">Desc. $</th>
                        <th scope="col" class="text-right">Recargo $</th>
                        <th scope="col" class="text-right">Total $</th>
                        <!-- <th scope="col">Motivo</th> -->
                        <!-- <th *ngIf="!additionalHeaderInfo.denyEditMotivo && !additionalHeaderInfo.denyEditCantidad"></th> -->
                      </tr>
                    </thead>
                    <tbody *ngIf="dataCabecera">
                      <tr *ngFor="let detalle of dataCabecera.detalleDocumento">
                        <td>
                          <mdb-checkbox [checked]="detalle.additionalInfo.checked" (change)='checkListaDoc(detalle)'>
                          </mdb-checkbox>
                        </td>
                        <td>{{ detalle.codigo_producto_proveedor }}</td>
                        <td>{{ detalle.descripcion_producto_proveedor }}</td>
                        <td>{{ detalle.cantidad }}</td>
                        <td>
                          <div class="m-0" style="max-width: 100px;">
                            <input value="" type="text" [id]="detalle.additionalInfo.id" class="form-control" required
                              monto min="1" [(ngModel)]="detalle.additionalInfo.Newcantidad" name="cantidad"
                              #cantidad="ngModel" [readonly]="detalle.additionalInfo.checked == false"
                              [disabled]="detalle.additionalInfo.checked == false"
                              (input)="devolucionChange(detalle, $event.target.value)" />
                            <div *ngIf="detalle.additionalInfo.Newcantidad > detalle.cantidad" style="color: #f44336;">
                              Cantidad no válida</div>
                          </div>
                        </td>
                        <td>{{ detalle.formato_codigo }}</td>
                        <td class="text-right">{{ detalle.precio_producto_proveedor | numerico }}</td>
                        <td class="text-right">{{ detalle.monto_descuento | numerico }}</td>
                        <td class="text-right">{{ detalle.monto_recargo | numerico }}</td>
                        <td class="text-right">{{ detalle.monto_total | numerico }}</td>
                        <!-- <td>
                          <mdb-select [options]="optionsMotivoGeneral" placeholder="Seleccionar motivo"
                            [readonly]="detalle.additionalInfo.checked == false" [disabled]="detalle.additionalInfo.checked == false"
                            [filterEnabled]="true" required [(ngModel)]="detalle.motivo_devolucion_especifico_codigo"
                            name="motivo_devolucion_especifico_codigo" #motivo_devolucion_especifico_codigo="ngModel" >
                          </mdb-select>
                          <div *ngIf="detalle.additionalInfo.checked == true" style="color: #f44336;">
                            Ingrese motivo</div>
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="this.formHeader.get('rutProveedor').value && this.formHeader.get('nFolio').value ">
            <div class="row" *ngIf="disabledTotales === true">
              <div class="col">
                <div class="table-responsive mt-1">
                  <table class="table table-striped table-hover table-sm align-middle">
                    <thead class="blue lighten-5">
                      <tr>
                        <th scope="col">SubTotal</th>
                        <th scope="col">Descto.</th>
                        <th scope="col">Recargo</th>
                        <th scope="col">TOTAL</th>
                      </tr>
                    </thead>
                    <tbody class="blue lighten-5">
                      <tr *ngIf=" this.formItems.get('productoExistente.tipoItems').value != 4">
                        <td>{{ subTotal | numerico }}</td>
                        <td>{{ Descto | numerico }}</td>
                        <td>{{ Recargo | numerico }}</td>
                        <td><strong>{{ Total | numerico }}</strong></td>
                      </tr>
                      <tr *ngIf=" this.formItems.get('productoExistente.tipoItems').value === 4">
                        <td>{{ subTotalsinSKU | numerico }}</td>
                        <td>{{ DesctosinSKU | numerico }}</td>
                        <td>{{ RecargosinSKU | numerico }}</td>
                        <td><strong>{{ TotalsinSKU | numerico }}</strong></td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
            </div>

            <br>
            <form autocomplete="off" [formGroup]="formMotivoGeneral" novalidate>
              <div class="row">
                <div class="col-4">
                  <mdb-select [options]="optionsMotivoGeneral" placeholder="Seleccionar motivo" [filterEnabled]="true"
                    formControlName="motivo">
                  </mdb-select>
                  <label class="title">Motivo</label>

                </div>
              </div>
            </form>

          </ng-container>

        </div>
      </div>

      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="CloseDocRecManualmente()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          [disabled]="(EnableButton===false)" (click)="saveDocRecManualmente()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-seleccion-documento [tipo_dte_codigo]="doctoReferencia" [es_nd]="true" [tipo_ncnd]="2"
  (onSelect)="onDocumentoSeleccionado($event)" (onNotFound)="onNotFoundDocumento($event)">
</app-modal-seleccion-documento>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>

<!-- MODAL SELECCIONAR PRODUCTO -->
<app-modal-seleccionar-producto-proveedor [enviaRutProveedor]="seleccionaRutProveedor"
  (onSelect)="onProductSeleccionado($event)" showInfoProveedorInactivoBloqueado="true"
  (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto-proveedor>

<!-- MODAL OBSERVACIONE -->
<app-modal-observaciones (onSelect)="saveObservaciones($event)">
</app-modal-observaciones>